/* para: CHECKED ITEMS(sections/recently-viewed.liquid)
   - localStorage「para:recently-viewed」= 商品 handle の配列(新しい順・重複なし・最大12件)
   - 表示: 現在の商品を除いた履歴を /products/<handle>?view=card(templates/product.card.liquid)で1件ずつ取得
     取得できない(非公開・削除・チップ)ものは表示せず履歴からも消す
   - 表示してから現在の商品を先頭に保存する(今見ている商品は自分の一覧に出さない)
   - localStorage が使えない環境(プライベートブラウズ等)では何もしない = セクションは非表示のまま */
(() => {
  if (customElements.get('para-recently-viewed')) return;

  const STORAGE_KEY = 'para:recently-viewed';
  const MAX_STORED = 12;
  const HANDLE_RE = /^[a-z0-9\-_\u0080-￿%]+$/i;

  function readHistory() {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      if (!Array.isArray(parsed)) return [];
      const seen = new Set();
      return parsed.filter((h) => {
        if (typeof h !== 'string' || !HANDLE_RE.test(h) || seen.has(h)) return false;
        seen.add(h);
        return true;
      });
    } catch (e) {
      return [];
    }
  }

  function writeHistory(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_STORED)));
    } catch (e) {
      /* 容量超過・プライベートブラウズ等では保存しない */
    }
  }

  function updateButtons(root) {
    const track = root.querySelector('.slider');
    const buttons = root.querySelector('.slider-buttons');
    if (!track || !buttons) return;
    const update = () => {
      buttons.hidden = track.scrollWidth - track.clientWidth <= 1;
    };
    update();
    if (!root.paraCarouselObserver && 'ResizeObserver' in window) {
      root.paraCarouselObserver = new ResizeObserver(update);
      root.paraCarouselObserver.observe(track);
    }
  }

  customElements.define(
    'para-recently-viewed',
    class ParaRecentlyViewed extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        this.wrapper = this.closest('.para-carousel-wrapper');
        this.track = this.querySelector('.slider');
        this.sectionId = this.dataset.sectionId;
        this.limit = parseInt(this.dataset.limit, 10) || MAX_STORED;
        this.root = this.dataset.root || '/';
        if (!this.root.endsWith('/')) this.root += '/';

        const current = this.dataset.productHandle || '';
        const history = readHistory();
        const toShow = history.filter((h) => h !== current).slice(0, this.limit);

        if (this.dataset.record === 'true' && current) {
          writeHistory([current, ...history.filter((h) => h !== current)]);
        }

        if (toShow.length) this.render(toShow);
      }

      async fetchCard(handle) {
        try {
          const response = await fetch(`${this.root}products/${encodeURIComponent(handle)}?view=card`, {
            credentials: 'same-origin',
          });
          if (!response.ok) return { handle, li: null, gone: response.status === 404 };
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const li = doc.querySelector('[data-para-card-list] > .slider__slide');
          return { handle, li, gone: !li };
        } catch (e) {
          return { handle, li: null, gone: false };
        }
      }

      async render(handles) {
        const results = await Promise.all(handles.map((h) => this.fetchCard(h)));

        // 404(非公開・削除)やチップだった handle は履歴から消す(通信エラーは消さない)
        const gone = new Set(results.filter((r) => r.gone).map((r) => r.handle));
        if (gone.size) writeHistory(readHistory().filter((h) => !gone.has(h)));

        const seenIds = new Set();
        results.forEach((r) => {
          if (!r.li) return;
          const id = r.li.dataset.productId;
          if (id && seenIds.has(id)) return;
          seenIds.add(id);
          this.track.appendChild(document.importNode(r.li, true));
        });

        const total = this.track.children.length;
        if (!total) return;

        this.track.querySelectorAll('.slider__slide').forEach((li, i) => {
          li.id = `Slide-${this.sectionId}-${i + 1}`;
        });
        const counter = this.querySelector('.slider-counter--total');
        if (counter) counter.textContent = total;
        if (this.wrapper) this.wrapper.hidden = false;

        await customElements.whenDefined('slider-component');
        const slider = this.querySelector('slider-component');
        if (slider && typeof slider.resetPages === 'function') slider.resetPages();
        updateButtons(this);
      }
    }
  );
})();
